import React, { Component, Fragment } from 'react';
import { Container, Row, Col, Input, Label, Button, Form, FormGroup } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes, faCircle, faTrashAlt, faGripLines } from '@fortawesome/free-solid-svg-icons'
import { faCircle as faCircleOutline } from '@fortawesome/free-regular-svg-icons'
import ReactDragListView from 'react-drag-listview'
import PermissionWrapper from '../../auth/PermissionWrapper';
import ConfirmButton from '../Modal/ConfirmButton';

class Services extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showInactive: true,
        };
    }

    standardParentRow = (service) => {
        this.props.log('Services.js/standardParentRow (service)', service);
        return (
            <Row className="adminRow pointer serviceRowParent" onClick={() => this.props.onEdit(service.serviceId, true)}>
                <Col md={4} className="text-left">
                    <FontAwesomeIcon icon={(service['active']) ? faCircle : faCircleOutline} className={"mr-3 " + ((service['active']) ? 'iconActive' : 'iconInactive')} />
                    {service['name']}
                </Col>
                <Col md={7} className="text-left"></Col>
                {/* <Col md={1}><Button><FontAwesomeIcon icon={faEdit} /></Button></Col> */}
                {(this.props.editParentService.serviceId === 0) ?
                    <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Reorder Services">
                        <Col md={1} className="text-right" onMouseDown={() => this.props.setDragTarget(null)}>
                            <span className="dragIconParent p-2"><FontAwesomeIcon icon={faGripLines} /></span>
                        </Col>
                    </PermissionWrapper>
                    : <></>}
            </Row>
        )
    }

    standardRow = (service) => {
        this.props.info('Services.js/standardRow (service)', service);
        return (
            <Row className="adminRow pointer serviceRow inactiveTab" onClick={() => this.props.onEdit(service.serviceId)}>
                <Col md={4} className="text-left pl-5">
                    <FontAwesomeIcon icon={(service['active']) ? faCircle : faCircleOutline} className={"mr-3 " + ((service['active']) ? 'iconActive' : 'iconInactive')} />
                    {service['name']}
                </Col>
                <Col md={7} className="text-left"></Col>
                {this.props.editService.serviceId === 0 ?
                    <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Reorder Services">
                        <Col md={1} className="text-right" onMouseDown={() => this.props.setDragTarget(null)}>
                            <span className="dragIcon p-2"><FontAwesomeIcon icon={faGripLines} /></span>
                        </Col>
                    </PermissionWrapper> : <></>}
            </Row>
        )
    }

    editRow = (service, parent = false) => {
        this.props.log('Services.js/editRow (service, parent)', service, parent);
        return (<>
            <Row key={"edit" + service.serviceId} className={"adminRow " + ((parent) ? (this.props.editService.serviceId === 0 ? "activeTab" : "activeTabHeader") : "activeTab")}>
                <Col md={9} className={"text-left " + (parent ? "" : "pl-5")}>
                    {(parent && this.props.editService.serviceId === 0) || !parent ?
                        <Form inline>
                            <FormGroup className="pr-2 pb-2">
                                <Input
                                    placeholder="Name"
                                    type="text"
                                    id={"edit-name" + service.serviceId + parent}
                                    name="name"
                                    value={this.props.isFieldNull(parent ? this.props.editParentService.name : this.props.editService.name)}
                                    onChange={e => this.props.onChange(e, 'edit', parent)} />
                            </FormGroup>
                            {!parent ? <FormGroup className="pr-2 pb-2">
                                <Input
                                    placeholder="Identifier"
                                    type="text"
                                    id={"edit-section" + service.serviceId + parent}
                                    name="section"
                                    value={this.props.isFieldNull(this.props.editService.section)}
                                    onChange={e => this.props.onChange(e, 'edit', parent)} />
                            </FormGroup> : <></>}
                            {parent ? <FormGroup className="pr-2 pb-2">
                                <Input
                                    placeholder="Column Headers"
                                    type="text"
                                    id={"edit-headers" + service.serviceId + parent}
                                    name="headers"
                                    value={this.props.isFieldNull(this.props.editParentService.headers)}
                                    onChange={e => this.props.onChange(e, 'edit', parent)} />
                            </FormGroup> : <></>}
                            {!parent ? <FormGroup className="pr-2 pb-2">
                                <Input
                                    placeholder="Max Entries"
                                    type="number"
                                    id={"edit-limit" + service.serviceId + parent}
                                    name="limit"
                                    value={this.props.isFieldNull(this.props.editService.limit)}
                                    onChange={e => this.props.onChange(e, 'edit', parent)} />
                            </FormGroup> : <></>}
                            {!parent ? <FormGroup className="pr-2 pb-2">
                                <Input
                                    type="select"
                                    id={"edit-serviceAreaId" + service.serviceId + parent}
                                    name="serviceAreaId"
                                    value={this.props.isFieldNull(this.props.editService.serviceAreaId)}
                                    onChange={e => this.props.onChange(e, 'edit', parent)} >
                                    <option value="">Select a Service Area</option>
                                    {this.props.serviceAreas.map(serviceArea => (
                                        <option key={serviceArea.serviceAreaId} value={this.props.isFieldNull(serviceArea.serviceAreaId)}>{serviceArea.serviceArea}</option>
                                    ))}
                                </Input>
                            </FormGroup> : <></>}
                            {!parent ? <FormGroup className="pr-2 pb-2">
                                <Input
                                    type="text"
                                    placeholder="Account Number"
                                    id={"edit-accountNumber" + service.serviceId + parent}
                                    name="accountNumber"
                                    value={this.props.isFieldNull(this.props.editService.accountNumber)}
                                    onChange={e => this.props.onChange(e, 'edit', parent)} />
                            </FormGroup> : <></>}
                            {!parent ? <FormGroup className="pr-2 pb-2">
                                <Input
                                    type="text"
                                    placeholder="Work Authorization Number"
                                    id={"edit-workAuthorizationNumber" + service.serviceId + parent}
                                    name="workAuthorizationNumber"
                                    value={this.props.isFieldNull(this.props.editService.workAuthorizationNumber)}
                                    onChange={e => this.props.onChange(e, 'edit', parent)} />
                            </FormGroup> : <></>}
                            <FormGroup className="pr-4 pb-2">
                                <Input
                                    type="checkbox"
                                    id={"edit-active" + service.serviceId + parent}
                                    name="active"
                                    checked={this.props.isFieldNull(parent ? this.props.editParentService.active : this.props.editService.active, true)}
                                    onChange={e => this.props.onChange(e, 'edit', parent)} />
                                <Label for={"edit-active" + service.serviceId + parent}>
                                    Active
                                </Label>
                            </FormGroup>
                        </Form> : <><FontAwesomeIcon icon={(service['active']) ? faCircle : faCircleOutline} className={"mr-3 " + ((service['active']) ? 'iconActive' : 'iconInactive')} />{service.name}</>}
                </Col>
                <Col md={3} className="text-right">
                    {(parent && this.props.editService.serviceId === 0) || !parent ? <>
                        <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Edit Services">
                            <Button className="mx-1" color="success" onClick={() => this.props.handleEdit(parent)} title="Edit Service">
                                <FontAwesomeIcon icon={faCheck} />
                            </Button>
                        </PermissionWrapper>
                        <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Delete Services">
                            <ConfirmButton className="mx-3" color="danger" onClick={() => this.props.onDelete(service.serviceId)}>
                                <FontAwesomeIcon icon={faTrashAlt} />
                            </ConfirmButton>
                        </PermissionWrapper>
                    </> : <></>}
                    <Button className="mx-1" color="secondary" onClick={() => this.props.handleCancel(parent)} title="Cancel">
                        <FontAwesomeIcon icon={faTimes} />
                    </Button>
                </Col>
                {parent ? <></> : <>
                    <Col md={1}></Col>
                    <Col md={2} className="text-right py-3 px-0">
                        Service Columns
                    </Col>
                    <Col md={4} className="text-left py-3">
                        <ReactDragListView {...this.props.dragProps}>
                            {[...this.props.serviceColumns].map(serviceColumn => {
                                const thisServiceColumns = this.props.editService.serviceColumns;
                                const newOrder = (thisServiceColumns.findIndex(item => item.serviceColumnId === serviceColumn.serviceColumnId) > -1) ?
                                    thisServiceColumns[thisServiceColumns.findIndex(item => item.serviceColumnId === serviceColumn.serviceColumnId)].order : serviceColumn.order * 100000;
                                return ({
                                    ...serviceColumn,
                                    order: newOrder
                                })
                            })
                                .sort((a, b) => a.order - b.order)
                                .map(serviceColumn => (
                                    <Row className="serviceRow" key={serviceColumn.serviceColumnId}>
                                        <Col md={2}></Col>
                                        <Col md={10}>
                                            <Label key={serviceColumn.serviceColumnId} for={"serviceColumn_" + serviceColumn.serviceColumnId}>
                                                <Input
                                                    type="checkbox"
                                                    name="serviceColumns"
                                                    id={"serviceColumn_" + serviceColumn.serviceColumnId}
                                                    checked={this.props.isFieldNull(this.props.editService.serviceColumns.findIndex(i => i.serviceColumnId === parseInt(serviceColumn.serviceColumnId)) > -1, true)}
                                                    onChange={e => this.props.onChange(e, 'edit')}
                                                />{serviceColumn.column}
                                            </Label>
                                        </Col>
                                    </Row>
                                ))}
                        </ReactDragListView>
                    </Col>
                    <Col md={1} className="text-right py-3 px-0">
                        Clients
                    </Col>
                    <Col md={4} className="text-left p-3 pl-5 maxHpanel">
                        {[...this.props.clients]
                            .map(client => (
                                <Row key={client.id}>
                                    <Label for={"serviceClient_" + client.id}>
                                        <Input
                                            type="checkbox"
                                            name="serviceClients"
                                            id={"serviceClient_" + client.id}
                                            checked={this.props.isFieldNull(this.props.editService.serviceClients.findIndex(i => i.clientId === parseInt(client.id)) > -1, true)}
                                            onChange={e => this.props.onChange(e, 'edit')}
                                        />{client.client}
                                    </Label>
                                </Row>
                            ))}
                    </Col></>}
            </Row>
        </>
        )
    }

    addRow = (parent = false) => {
        this.props.info('Services.js/addRow (parent)', parent);
        return (
            <Row className="py-4 text-left align-items-bottom ">
                <Col md={10} className={(parent ? "" : "pl-5")}>
                    <Form inline>
                        {/* <FormGroup className="pr-2">
              Add New {parent ? "Parent" : ""} Service
            </FormGroup> */}
                        <FormGroup className="pr-2 pb-2">
                            <Input
                                placeholder="New Service Name"
                                type="text"
                                id={"service-add-name" + parent}
                                name="name"
                                value={this.props.isFieldNull(parent ? this.props.newParentService.name : this.props.newService.name)}
                                onChange={e => this.props.onChange(e, '', parent)} />
                        </FormGroup>
                        {!parent ? <FormGroup className="pr-2  pb-2">
                            <Input
                                placeholder="Identifier"
                                type="text"
                                id={"service-add-section" + parent}
                                name="section"
                                value={this.props.isFieldNull(this.props.newService.section)}
                                onChange={e => this.props.onChange(e, '', parent)} />
                        </FormGroup> : <></>}
                        {parent ? <FormGroup className="pr-2 pb-2">
                            <Input
                                placeholder="Column Headers"
                                type="text"
                                id={"service-add-headers" + parent}
                                name="headers"
                                value={this.props.isFieldNull(this.props.newParentService.headers)}
                                onChange={e => this.props.onChange(e, '', parent)} />
                        </FormGroup> : <></>}
                        {!parent ? <FormGroup className="pr-2 pb-2">
                            <Input
                                placeholder="Max Entries"
                                type="number"
                                id={"service-add-limit" + parent}
                                name="limit"
                                value={this.props.isFieldNull(this.props.newService.limit)}
                                onChange={e => this.props.onChange(e, '', parent)} />
                        </FormGroup> : <></>}
                        {!parent ? <FormGroup className="pr-2 pb-2">
                            <Input
                                type="select"
                                id={"service-add-serviceAreaId" + parent}
                                name="serviceAreaId"
                                value={this.props.isFieldNull(this.props.newService.serviceAreaId)}
                                onChange={e => this.props.onChange(e, '', parent)}>
                                <option value="">Select a Service Area</option>
                                {this.props.serviceAreas.map(serviceArea => (
                                    <option key={serviceArea.serviceAreaId} value={this.props.isFieldNull(serviceArea.serviceAreaId)}>{serviceArea.serviceArea}</option>
                                ))}
                            </Input>
                        </FormGroup> : <></>}
                        {!parent ? <FormGroup className="pr-2 pb-2">
                            <Input
                                placeholder="Account Number"
                                type="text"
                                id={"service-add-accountNumber" + parent}
                                name="accountNumber"
                                value={this.props.isFieldNull(this.props.newService.accountNumber)}
                                onChange={e => this.props.onChange(e, '', parent)} />
                        </FormGroup> : <></>}
                        {!parent ? <FormGroup className="pr-2 pb-2">
                            <Input
                                placeholder="Work Authorization Number"
                                type="text"
                                id={"service-add-workAuthorizationNumber" + parent}
                                name="workAuthorizationNumber"
                                value={this.props.isFieldNull(this.props.newService.workAuthorizationNumber)}
                                onChange={e => this.props.onChange(e, '', parent)} />
                        </FormGroup> : <></>}
                        <FormGroup className="pr-4 pb-2">
                            <Input
                                type="checkbox"
                                id={"service-add-active" + parent}
                                name="active"
                                checked={this.props.isFieldNull(parent ? this.props.newParentService.active : this.props.newService.active, true)}
                                onChange={e => this.props.onChange(e, '', parent)} />
                            <Label for={"service-add-active" + parent}>
                                Active
                            </Label>
                        </FormGroup>
                    </Form>
                </Col>
                <Col md={2} className="text-right">
                    <Button
                        disabled={parent ? this.props.newParentService.name === '' : this.props.newService.name === ''}
                        color="primary"
                        onClick={() => this.props.handleAdd(parent)}
                    >Add Service</Button>
                </Col>
            </Row>
        )
    }

    render() {
        this.props.info('Services.js/render');
        return (
            <>
                <Container fluid>
                    <Row>
                        <Col className='text-right'>
                            <Label><Input checked={this.state.showInactive} name="showInactive" type="checkbox" onChange={() => this.setState({ showInactive: !this.state.showInactive })} />Show Inactive</Label>
                        </Col>
                    </Row>
                </Container>
                <Container className="adminContainer" fluid>
                    <ReactDragListView {...this.props.dragPropsParent}>
                        {this.props.services.filter(parentService => (this.state.showInactive || (!this.state.showInactive && parentService.active))).map(parentService => (
                            <Fragment key={parentService.serviceId}>{this.props.editParentService.serviceId === parentService.serviceId ?
                                <>{this.editRow(parentService, true)}
                                    {parentService.services != null ?
                                        <ReactDragListView {...this.props.dragProps}>
                                            {parentService.services.filter(childService => (this.state.showInactive || (!this.state.showInactive && childService.active && childService.clients != null && childService.fields != null))).map(childService => (
                                                <Fragment key={childService.serviceId}>{this.props.editService.serviceId === childService.serviceId ? this.editRow(childService) :
                                                    this.standardRow(childService)}</Fragment>
                                            ))}
                                        </ReactDragListView>
                                        : <></>}
                                    {this.addRow()}
                                </> : this.standardParentRow(parentService, true)}</Fragment>
                        ))}
                        <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Add Services">
                            {this.props.editParentService.serviceId === 0 ? this.addRow(true) : null}
                        </PermissionWrapper>
                    </ReactDragListView>
                </Container>
            </>
        );

    }
}

export default Services;
